var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconcoolIconN11(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2696_387)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2696_387)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_2696_387)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.7754 21.6055H21.2247V26.3301H11.7754V21.6055Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4997 3.65234C10.7683 3.65234 6.10547 8.31527 6.10547 14.0466V28.2206C6.10547 30.3047 7.80105 32.0003 9.8852 32.0003H23.1142C25.1984 32.0003 26.894 30.3047 26.894 28.2206V14.0466C26.894 8.31521 22.2312 3.65234 16.4997 3.65234ZM10.8301 12.1567H22.1693V14.0466H20.2795V15.9365H18.3896V14.0466H10.8301V12.1567ZM23.1142 28.2206H9.8852V19.7162H23.1142V28.2206Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2042 1.83877L20.8411 0L20.0566 2.288C21.9519 2.86245 23.6545 3.88336 25.0422 5.22799L26.2042 1.83877Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9425 2.288L12.158 0L6.79492 1.83877L7.95694 5.22799C9.3446 3.88342 11.0473 2.86245 12.9425 2.288Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2696_387"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2696_387"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_2696_387"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.7885,
    height: 32,
    fill: "white",
    transform: "translate(6.10547)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconcoolIconN11);
export default __webpack_public_path__ + "static/media/icon cool-icon-n11.1ee5ac2d88493ce15dec1534145e1e15.svg";
export { ForwardRef as ReactComponent };